<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import axios from "axios";
import { TicketsPath } from "@/path";
import Swal from "sweetalert2";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      form: {
        dates: [],
      },
      date_range: [],
      dates_selected: [],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      retraining: [
        { value: null, text: "Select Training" },
        {
          value: "retraining_for_existing_brand",
          text: "Retraining for Existing Brand",
        },
        {
          value: "new_staff_training",
          text: "New Staff Training",
        },
      ],
      selected_type: null,
      showDatesSelectedAlert: false,
      showSelectedTypeAlert: false,
      showSelectedSlotsAlert: false,
    };
  },
  watch: {
    date_range(newDates) {
      this.dates_selected = newDates.map((date) =>
        moment(date).format("MMMM Do YYYY")
      );
      this.showDatesSelectedAlert = false;
    },
    form: {
      deep: true,
      handler() {
        this.showSelectedSlotsAlert = false;
      },
    },
    selected_type() {
      this.showSelectedTypeAlert = false;
    },
  },
  methods: {
    hideKeyboard() {
      Array.from(document.querySelectorAll("input")).forEach((el) => el.blur());
    },
    removeDate(index) {
      this.date_range.splice(index, 1);
      this.dates_selected.splice(index, 1);
      this.$delete(this.form, `slot${index * 2 + 1}`);
      this.$delete(this.form, `slot${index * 2 + 2}`);
    },
    setSlot(index, e, slot) {
      console.log(index, e, slot, "mmm");
      let fi = this.form.dates.findIndex(
        (f) => f.date == this.dates_selected[index]
      );
      if (e == "true") {
        if (fi !== -1) {
          this.form.dates[fi].slots.push(slot);
        } else {
          this.form.dates.push({
            date: this.dates_selected[index],
            slots: [slot],
          });
        }
      } else {
        if (fi !== -1) {
          let si = this.form.dates[fi].slots.findIndex((f) => f == slot);
          if (si !== -1) {
            this.form.dates[fi].slots.splice(si, 1);
          }
        }
      }
    },
    isDisabledDate(date) {
      const today = new Date();
      const twoDaysFromNow = new Date(today);
      const tenDaysFromNow = new Date(today);

      twoDaysFromNow.setDate(today.getDate() + 2);
      twoDaysFromNow.setHours(0, 0, 0, 0); // Set to midnight for comparison

      tenDaysFromNow.setDate(today.getDate() + 15);
      tenDaysFromNow.setHours(0, 0, 0, 0); // Set to midnight for comparison

      // Disable past dates including today and dates after the next 10 days
      if (date < twoDaysFromNow || date > tenDaysFromNow) {
        return true;
      }

      // Disable Sundays
      const day = date.getDay();
      if (day === 0) {
        return true;
      }

      // Optionally disable specific dates
      const disabledDates = [new Date(2019, 10, 2), new Date(2019, 10, 6)];
      for (const disabledDate of disabledDates) {
        if (
          date.getFullYear() === disabledDate.getFullYear() &&
          date.getMonth() === disabledDate.getMonth() &&
          date.getDate() === disabledDate.getDate()
        ) {
          return true;
        }
      }

      return false;
    },
    async saveTicket() {
      try {
        if (this.dates_selected.length == 0) {
          this.showDatesSelectedAlert = true;
          return;
        }
        if (this.form.dates.length == 0) {
          this.showSelectedSlotsAlert = true;
          return;
        }
        if (!this.selected_type) {
          this.showSelectedTypeAlert = true;
          return;
        }
        this.form.selected_type = this.selected_type;
        let res = await axios.post(this.baseUrl + TicketsPath.SAVE_TICKET, {
          category: "retraining",
          extra_details: this.form,
        });
        if (res.data.status) {
          Swal.fire(
            "Ticket Raised Successfully for Training",
            "",
            "success"
          ).then(() => {
            this.$router.push("/tickets_dashboard");
          });
        } else {
          throw new Error("Failed to save");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <div>
    <b-row style="color: black">
      <b-col sm="8" md="6" lg="6" xl="4" cols="12">
        <b-form-group>
          <label style="font-weight: 400; font-size: 16px"
            >Select any four dates:</label
          >
          <date-picker
            ref="datePicker-1"
            v-model="date_range"
            @focus="hideKeyboard"
            multiple
            :disabled-date="isDisabledDate"
            :disabled="dates_selected.length == 4"
          ></date-picker>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        style="color: black; font-size: 16px"
        s
      >
        <b-form-group label="Select Type of Training:">
          <b-form-select
            v-model="selected_type"
            :options="retraining"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="dates_selected.length">
        <p style="font-size: 16px; padding-bottom: 10px">Select Slots</p>
      </b-col>
      <template v-for="(date, index) in dates_selected">
        <b-col cols="12" sm="4" :key="date">
          <div
            style="
              border: 1px solid rgb(220, 220, 220);
              margin-bottom: 5px;
              padding: 10px;
              border-radius: 5px;
            "
          >
            <div style="display: flex; justify-content: space-between">
              <h6>{{ date }}</h6>
              <b-button
                style="
                  border: 0px;
                  padding: 0px;
                  background-color: white;
                  opacity: 1;
                  font-size: large;
                  margin-top: -10px;
                  height: max-content;
                "
                @click="removeDate(index)"
              >
                <span style="color: rgba(255, 0, 0, 0.6)"> &times; </span>
              </b-button>
            </div>
            <b-form-checkbox
              :id="'checkbox' + (index * 2 + 1)"
              @change="setSlot(index, $event, '11:00 AM - 01:00 PM')"
              value="true"
              unchecked-value="false"
              >11:00 AM - 01:00 PM</b-form-checkbox
            >
            <b-form-checkbox
              :id="'checkbox' + (index * 2 + 2)"
              @change="setSlot(index, $event, '03:00 PM - 05:00 PM')"
              value="true"
              unchecked-value="false"
              >03:00 PM - 05:00 PM</b-form-checkbox
            >
          </div>
        </b-col>
      </template>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showDatesSelectedAlert" variant="danger" dismissible>
          Please select Dates for Retraining and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showSelectedSlotsAlert" variant="danger" dismissible>
          Please select slots of the selected dates for Retraining and Raise
          Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showSelectedTypeAlert" variant="danger" dismissible>
          Please select the type of Training and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          type="submit"
          variant="primary"
          @click="saveTicket"
          style="margin-bottom: 100px"
          >Raise Ticket</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<style></style>
